import styled from 'styled-components'
import MaskedInput from 'react-input-mask'

export const Mask = styled(MaskedInput)`
  width: 100%;
  height: 100%;
  border: none;
`
